// removed by extract-text-webpack-plugin
module.exports = {"overlay":"c-Overlay__overlay"};